import { useRef, useState, useId } from "react";
import { listOfCountries } from "../../Utilities/listOfCountries";
import emailjs from "@emailjs/browser";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Store } from "react-notifications-component";

export const ComponentHomeClubConnectForm = () => {
    const { t } = useTranslation();
    
    const agreeCommunicationId = useId();
    const agreeDataId = useId();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        data_fname: "",
        data_lname: "",
        data_email: "",
        data_number: "",
        data_club: "",
        data_other: "",
    });
    const [selectedCountryValue, setSelectedCountryValue] = useState("DEFAULT");

    const handleChange = (e) => {
        const { name, value } = e.target;
    
        // Prevent leading spaces and trim trailing spaces
        setFormData((prev) => ({
          ...prev,
          [name]: value.replace(/^\s+/, ""),
        }));
      };

    const handlePhoneNumberChange = (event) => {
        const { name, value } = event.target;

        // Use regex to remove non-numeric characters from the input value
        setFormData((prev) => ({
            ...prev,
            [name]: value.replace(/\D/g, ""),
          }));
    };

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault(); // prevents the page from reloading when you hit “Send”
        setLoading(true);
        emailjs
            .sendForm(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                form.current,
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            )
            .then(
                () => {
                    setLoading(false);
                    resetForm();
                    Store.addNotification({
                        title: null,
                        message: t("HomeClubConnectForm.SuccessMessage"),
                        type: "success",
                        insert: "center",
                        container: "bottom-center",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 3000
                        }
                    });
                },
                () => {
                    setLoading(false);
                    Store.addNotification({
                        title: null,
                        message: t("HomeClubConnectForm.ErrorMessage"),
                        type: "danger",
                        insert: "center",
                        container: "bottom-center",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                            duration: 3000
                        }
                    });
                }
            );
    };

    const resetForm = () => {
        form.current.reset();
        setFormData({
            data_fname: "",
            data_lname: "",
            data_email: "",
            data_number: "",
            data_club: "",
            data_other: "",
        })
    };

    return (
        <form
            ref={form}
            className="px-8 py-14 text-secondary bg-[#fafafa] rounded-3xl relative overflow-hidden"
            id="formLink"
            onSubmit={sendEmail}
        >
            {loading ? (
                <div className="absolute left-0 top-0 w-full h-full bg-black/[0.1] z-10 flex justify-center items-center">
                    <div className="w-full h-[100px] flex justify-center">
                        <div className="flex justify-center items-center">
                            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-secondary"></div>
                        </div>
                    </div>
                </div>
            ) : null}
            <h3 className="text-3xl xl:text-4xl 2xl:text-[45px] font-semibold mb-2 xl:mb-3 2xl:mb-4">
                {t("HomeClubConnectForm.mainTitle")}
            </h3>
            <h3 className="xl:text-2xl 2xl:text-3xl text-xl font-semibold">
                {t("HomeClubConnectForm.title")}
            </h3>
            <div className="flex flex-col gap-8 w-full mt-11 text-secondary">
                <div className="flex flex-col gap-8 sm:flex-row sm:gap-5 justify-between w-full">
                    <div className="relative w-full sm:w-[calc(50%-10px)]">
                        <input
                            id="firstNameField"
                            className="h-[46px] sm:h-[62px] w-full bg-white text-secondary rounded-full px-4 py-1 ring-2 ring-[#000b2970] placeholder-[#808080] focus:outline-none focus:ring-secondary"
                            name="data_fname"
                            value={formData?.data_fname}
                            required
                            placeholder={t("HomeClubConnectForm.FirstName")}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="relative w-full sm:w-[calc(50%-10px)]">
                        <input
                            id="lastNameField"
                            className="h-[46px] sm:h-[62px] w-full bg-white text-secondary rounded-full px-4 py-1 ring-2 ring-[#000b2970] placeholder-[#808080] focus:outline-none focus:ring-secondary"
                            name="data_lname"
                            value={formData?.data_lname}
                            placeholder={t("HomeClubConnectForm.LastName")}
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <div className="flex flex-wrap gap-5 justify-between w-full">
                    <div className="relative w-full sm:w-[calc(50%-10px)]">
                        <input
                            id="emailField"
                            className="h-[46px] sm:h-[62px] w-full bg-white text-secondary rounded-full px-4 py-1 ring-2 ring-[#000b2970] placeholder-[#808080] focus:outline-none focus:ring-secondary"
                            type="email"
                            name="data_email"
                            value={formData?.data_email}
                            required
                            placeholder={t("HomeClubConnectForm.Email")}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="relative w-full sm:w-[calc(50%-10px)]">
                        <input
                            id="phoneNumberField"
                            className="h-[46px] sm:h-[62px] w-full bg-white text-secondary rounded-full px-4 py-1 ring-2 ring-[#000b2970] placeholder-[#808080] focus:outline-none focus:ring-secondary"
                            type="tel"
                            value={formData?.data_number}
                            onChange={handlePhoneNumberChange}
                            name="data_number"
                            placeholder={t("HomeClubConnectForm.Phone")}
                        />
                    </div>
                </div>
                <div className="flex flex-wrap gap-5 justify-between w-full">
                    <div className="relative w-full sm:w-[calc(50%-10px)]">
                        <input
                            id="clubNameField"
                            className="h-[46px] sm:h-[62px] w-full bg-white text-secondary rounded-full px-4 py-1 ring-2 ring-[#000b2970] placeholder-[#808080] focus:outline-none focus:ring-secondary"
                            name="data_club"
                            value={formData?.data_club}
                            required
                            placeholder={t("HomeClubConnectForm.ClubName")}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="relative w-full sm:w-[calc(50%-10px)]">
                        <select
                            id="selectSportField"
                            className="h-[46px] sm:h-[62px] w-full bg-white  text-secondary cursor-pointer rounded-full px-4 py-1 ring-[#000b2970] ring-2 text-[#000B2999] border-r-[16px] border-r-transparent placeholder-[#808080] focus:outline-none focus:ring-secondary"
                            // onChange={handleSportChange}
                            name="data_sport"
                            placeholder={t("HomeClubConnectForm.Sports.title")}
                        >
                            <option id="selectSportOP1" value="Padel">
                                {t("HomeClubConnectForm.Sports.opt-1")}
                            </option>
                            <option id="selectSportOP2" value="Tennis">
                                {t("HomeClubConnectForm.Sports.opt-2")}
                            </option>
                            <option id="selectSportOP3" value="Badminton">
                                {t("HomeClubConnectForm.Sports.opt-3")}
                            </option>
                            <option id="selectSportOP4" value="Pickle Ball">
                                {t("HomeClubConnectForm.Sports.opt-4")}
                            </option>
                            <option id="selectSportOP5" value="Squash">
                                {t("HomeClubConnectForm.Sports.opt-5")}
                            </option>
                            <option id="selectSportOP6" value="Golf">
                                {t("HomeClubConnectForm.Sports.opt-6")}
                            </option>
                        </select>
                        <div className="absolute top-[calc(50%+2px)] right-4 transform -translate-y-1/2 pointer-events-none bg-white">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="20"
                                height="20"
                                fill="none"
                                stroke="#808080"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <path d="M6 9l6 6 6-6" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="relative">
                    <select
                        id="selectCountryField"
                        className={`h-[46px] sm:h-[62px] w-full bg-white outline-secondary cursor-pointer rounded-full px-4 py-1  ring-[#000b2970] ring-2 text-[#000B2999] border-r-[16px] border-r-transparent placeholder-[#808080] focus:outline-none focus:ring-secondary ${selectedCountryValue === "DEFAULT" ? "text-[#808080]" : "text-secondary"}`}
                        name="data_country"
                        placeholder="Centre location here..."
                        defaultValue={"DEFAULT"}
                        onChange={(e)=>{setSelectedCountryValue(e.target.value)}}
                    >
                        <option id="selectCountryDefault" value="DEFAULT" disabled>
                            {t("HomeClubConnectForm.countryOpt")}
                        </option>
                        {listOfCountries.map((country, index) => (
                            <option id={`selectCountry${index}`} key={index} value={country}>
                                {country}
                            </option>
                        ))}
                    </select>
                    <div className="absolute top-[calc(50%+2px)] right-4 transform -translate-y-1/2 pointer-events-none bg-white">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="20"
                            height="20"
                            fill="none"
                            stroke="#808080"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M6 9l6 6 6-6" />
                        </svg>
                    </div>
                </div>
                <div className="relative">
                    <textarea
                        id="otherInfoField"
                        className="min-h-[46px] h-[46px] sm:h-[62px] sm:min-h-[62px] w-full bg-white text-secondary rounded-[32px] px-4 py-2.5 sm:py-[18px] ring-2 ring-[#000b2979] placeholder-[#808080] focus:outline-none focus:ring-secondary"
                        name="data_other"
                        value={formData?.data_other}
                        placeholder={t("HomeClubConnectForm.other")}
                        onChange={handleChange}
                    />
                </div>
                <div className="flex items-center">
                    <input
                        type="checkbox"
                        className="h-5 w-5"
                        id={`agree-communication-${agreeCommunicationId}`}
                        name="agree-communication"
                    />
                    <label
                        htmlFor={`agree-communication-${agreeCommunicationId}`}
                        className="ml-2 text-secondary"
                    >
                        {t("HomeClubConnectForm.AgreeToReceiveOffer")}
                    </label>
                </div>
                <div className="flex items-center">
                    <input
                        type="checkbox"
                        className="h-5 w-5"
                        id={`agree-data-${agreeDataId}`}
                        name="agree-data"
                    />
                    <label
                        htmlFor={`agree-data-${agreeDataId}`}
                        className="ml-2 text-secondary"
                    >
                        {t("HomeClubConnectForm.AgreeToStoreData")}
                    </label>
                </div>

                <p className="text-lg text-secondary">
                    {t("HomeClubConnectForm.CheckBox")}{" "}
                    <span className="underline">
                        <NavLink
                            style={{ color: "black" }}
                            to="/en/privacy-policy-1"
                        >
                            {t("Privacy")}
                        </NavLink>
                    </span>
                </p>
                <input
                    type="submit"
                    value={t("HomeClubConnectForm.Submit")}
                    className="w-full h-12 sm:h-16 rounded-full px-4 py-1 flex justify-center items-center bg-secondary text-xl font-medium text-white cursor-pointer hover:bg-white hover:text-secondary hover:border-2 transform duration-200"
                />
            </div>
        </form>
    );
};
